import React from "react";

const PrProductTable = ({ revData = [], isLoading = false }) => {
  const products = revData[0]?.revProduct || [];

  if (isLoading) {
    return (
      <div className="w-full bg-white border mt-4 rounded-lg p-4 space-y-3">
        <div className="h-8 bg-slate-200 rounded animate-pulse w-full mb-2"></div>
        {[...Array(3)].map((_, idx) => (
          <div key={idx} className="h-6 bg-slate-100 rounded animate-pulse w-full"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="w-full bg-white border mt-4 rounded-lg overflow-x-auto min-w-0">
      {/* Header */}
      <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-t-lg min-w-[500px] px-2">
        <p className="w-[5%] text-center text-white text-xs font-medium">S.No</p>
        <p className="w-[60%] text-left text-white text-xs font-medium">Product</p>
        <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
        <p className="w-[15%] text-center text-white text-xs font-medium">Quantity</p>
      </div>

      {/* Rows */}
      {products.length > 0 ? (
        products.map((item, index) => (
          <div
            key={index}
            className="w-full py-2.5 flex justify-between odd:bg-white even:bg-slate-50 border-b last:border-b-0 border-slate-100 min-w-[500px] px-2 items-center"
          >
            <p className="w-[5%] text-center text-xs font-medium text-[#111537]">
              {index + 1}
            </p>
            <p className="w-[60%] text-left text-xs font-medium text-[#111537] break-words pr-2">
              {item?.product_name || "N/A"}
            </p>
            <p className="w-[10%] text-center text-xs font-medium text-[#111537]">
              {item?.product_unit || "-"}
            </p>
            <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
              {item?.quantity ?? 0}
            </p>
          </div>
        ))
      ) : (
        <div className="w-full py-8 text-center text-xs text-[#9DA3AA]">
          No items requested for this PR
        </div>
      )}
    </div>
  );
};

export default React.memo(PrProductTable);
